import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { CmsAnalytics } from 'apps/cms/lib/analytics'
import { contentManagementActions, contentManagementSelectors } from 'apps/cms/store'
import { openAutomationStartersModal } from 'common/core/actions/uiActions'
import {
  hasConnectedInstagramChannel,
  hasConnectedTelegramChannel,
  hasConnectedTiktokChannel,
  isFBChannelConnected,
} from 'common/core/selectors/channelSelectors'
import * as settingsSelectors from 'common/settings/selectors/settingsSelectors'
import { getFlowUrlByPath } from 'utils/router/tools/cms'
import { useHotjar } from 'utils/services/hotjar/useHotjar'

export const useNewAutomationButton = () => {
  const dispatch = useAppDispatch()
  const flowPath = useAppSelector(contentManagementSelectors.getFlowPath)

  const { hotjarTrigger } = useHotjar()
  const navigate = useNavigate()
  const { disableFlowCreation } = useAppSelector(contentManagementSelectors.getUi)

  const showTemplatesModal = useAppSelector(
    (state) =>
      settingsSelectors.isQuickCampaignsEnabled(state) &&
      (isFBChannelConnected(state) ||
        hasConnectedInstagramChannel(state) ||
        hasConnectedTelegramChannel(state) ||
        hasConnectedTiktokChannel(state)),
  )

  const createAutomation = useCallback(async () => {
    dispatch(contentManagementActions.setIsFlowCreationStarted(true))

    if (disableFlowCreation) {
      CmsAnalytics.logCreateAutomationModalSelectFlow()
      hotjarTrigger('new_flow_from_select_flow_clicked', ['new_flow_from_select_flow_clicked'])
      return
    }

    CmsAnalytics.logCreateAutomation()
    hotjarTrigger('new_flow_clicked', ['new_flow_clicked'])

    if (showTemplatesModal) {
      dispatch(openAutomationStartersModal())
    } else {
      const data = await dispatch(
        contentManagementActions.createAutomation({ path: flowPath }),
      ).unwrap()
      if (!data) return

      navigate(getFlowUrlByPath(data.fs_object.path))
    }
  }, [dispatch, disableFlowCreation, hotjarTrigger, flowPath, navigate, showTemplatesModal])

  return {
    createAutomation,
  }
}
